import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';
import styles from './index.css';

class ModuleHead extends React.PureComponent {
    static propTypes = {
        chipConfig: PropTypes.object,
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content, chipConfig } = this.props;

        return (
            <Chip {...chipConfig}>
                <div className={styles.moduleHead}>
                    <div className={styles.moduleHeadLine} />
                    <div className={styles.moduleHeadTitle}>{content?.name || ''}</div>
                    {content?.url && (
                        <a target="_blank" href={content.url} className={styles.moduleHeadMore}>
                            更多
                        </a>
                    )}
                </div>
            </Chip>
        );
    }
}

export default errorBoundary(ModuleHead);
